import { Form, InputGroup, Button } from 'react-bootstrap';

function format(value) {
	if (!value || typeof value !== 'string') return value;

	const parcelNumber = value.replace(/[^\d]/g, '');
	if (parcelNumber.length < 3) {
		return parcelNumber;
	}
	if (parcelNumber.length < 6) {
		return `${parcelNumber.slice(0, 2)}:${parcelNumber.slice(2)}`;
	}

	return `${parcelNumber.slice(0, 2)}:${parcelNumber.slice(
		2,
		5
	)}:${parcelNumber.slice(5, 9)}`;
}

export const ParcelNumber = ({
	registerName = 'parcelNumber',
	id,
	register,
	enableRemove = false,
	onRemove = () => {},
}) => {
	const handleInput = e => {
		const formattedPhoneNumber = format(e.target.value);
		e.target.value = formattedPhoneNumber;
	};

	return (
		<div className="mb-2">
			<InputGroup>
				<Form.Control
					{...register(registerName, {
						onChange: handleInput,
						setValueAs: format,
					})}
					type="text"
				/>
				{enableRemove === true && (
					<Button
						variant="danger"
						onClick={() => {
							onRemove(id);
						}}>
						Remove
					</Button>
				)}
			</InputGroup>
		</div>
	);
};
